export type MonthlyNormalizationFactor = {
  locationId: number;
  month: number;
  year: number;
  normalizationValue: number;
};

export type Location = {
  id: number;
  name: string;
  normalFactor: number;
  monthlyNormalizationFactors?: MonthlyNormalizationFactor[];
};

export class Level {
  id: number;
  name: string;
  parentId: number | null;
  isBuilding: boolean;
  hasChildren: boolean;
  parent?: Level | null;
  locationId?: number | null;
  location?: Location | null;

  constructor(level: Level) {
    this.id = level.id;
    this.name = level.name;
    this.parentId = level.parentId;
    this.isBuilding = level.isBuilding;
    this.hasChildren = level.hasChildren;
    this.parent = level?.parent;
    this.locationId = level.locationId;
    this.location = level.location;
  }
}
